import selectPositionModalTemplate from "../views/modals/select-positions-modal.tpl.html";

class CancelInvoiceModalCtrl {

    constructor(Invoice, $uibModalInstance, invoice, InvoiceTemplate, $scope, Users, $http, $injector) {
        this.invoiceModel = Invoice;
        this.invoiceTemplateModel = InvoiceTemplate;
        this.invoice = invoice;

        this.modalInstance = $uibModalInstance;
        this.invoiceToCancel = invoice;
        this.scope = $scope;
        this.userStore = Users;
        this.api = $http;
        this.injector = $injector;
        this.modal = $injector.get('$uibModal');

        this.data = {
            invoice_template_id: null,
            cancellation_date: new Date(),
            cancel_shipping_costs: _.get(this.userStore.state.company, 'settings.billing.cancellation_shipping_costs_default', false),
            cancel_processing_costs: _.get(this.userStore.state.company, 'settings.billing.cancellation_processing_costs_default', false),
            charge_cancellation_fee: _.get(this.userStore.state.company, 'settings.billing.charge_cancellation_fee_default', false),
            cancellation_fee_type: _.get(this.userStore.state.company, 'settings.billing.default_cancellation_fee_type', 'percent'),
            cancellation_fee_percent: 0,
            cancellation_fee_amount: 0,
            positions: invoice.positions.data.map((p) => ({...p, enabled: true})),
            custom_positions: []
        };

        if (this.data.cancellation_fee_type === 'fixed_amount') {
            this.data.cancellation_fee_amount = _.get(this.userStore.state.company, 'settings.billing.default_cancellation_fee_value', 0);
        } else {
            this.data.cancellation_fee_percent = _.get(this.userStore.state.company, 'settings.billing.default_cancellation_fee_value', 0);
        }
        this.template = null;
        this.invoiceTemplates = [];
        this.submitting = false;
        this.loading = false;

        this._loadTemplates();
        this._initWatchers();
    }

    _loadTemplates() {
        this.loading = true;
        this.invoiceTemplates = [];
        this.invoiceTemplateModel.getList().then((collection) => {
            _.forEach(collection, (v, k) => {
                if (v.enable_for_cancellation) {
                    this.invoiceTemplates.push(v.plain());
                }
            });

            if (!this.template) {
                this.template = this.invoiceTemplates[0];
            }

            this.loading = false;
        });
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.template;
        }, (value) => {
            if (this.template) {
                this.data.invoice_template_id = this.template.id;
            }
        });

        this.scope.$watch(() => {
            return this.data.positions;
        }, (newPositions) => {
            newPositions.filter((position) => position.bundle_position_id === null)
                        .forEach((bundlePosition) => this._toggleBundlePosition(bundlePosition));
        }, true);

    }

    _toggleBundlePosition(bundlePosition) {
        this.data.positions.filter((position) => position.bundle_position_id === bundlePosition.id)
            .forEach((position) => position.enabled = bundlePosition.enabled);
    }

    _getEnabledPositions() {
        return this.data.positions
                   .filter((position) => position.enabled)
                   .map((position) => position.id);
    }

    submit() {
        const positions = this._getEnabledPositions();

        this.submitting = true;
        return this.invoiceModel.cancelInvoice(this.invoiceToCancel, {...this.data, positions}).then((cancellation) => {
            this.modalInstance.close({
                cancellation: cancellation
            });
        }, (e) => {
            this.modalInstance.dismiss(e);
        });
    }

    uncheckAll() {
        this.data.positions.forEach((position) => {
            position.enabled = false;
        })
    }

    checkAll() {
        this.data.positions.forEach((position) => {
            position.enabled = true;
        })
    }

    addCustomPosition() {
        this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: selectPositionModalTemplate,
            size: 'md',
            controller: 'BillingSelectPositionController',
            controllerAs: 'vm'
        }).result.then((data) => {
            this.data.custom_positions.push({
                needsCreation: true,
                enabled: true,
                order: this.data.custom_positions.length + 1,
                position_id: data.id,
                label: data.label,
                description: data.description,
                price_per_unit: 0-data.price_per_unit,
                unit: data.unit,
                tax_rate: data.tax_rate,
                amount: 1,
                billable: null,
                billable_type: null,
                billable_id: null
            });
        }, () => {

        });
    }

    dismiss() {
        this.modalInstance.dismiss(true);
    }
}

CancelInvoiceModalCtrl.$inject = [
    'Invoice',
    '$uibModalInstance',
    'invoice',
    'InvoiceTemplate',
    '$scope',
    'Users',
    '$http',
    '$injector'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesCancelModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesCancelModalCtrl', CancelInvoiceModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/cancel-invoice-modal-controller.js